import { makeSx } from '@saas/lib/shared-utils'
import { palette } from '../../../utilities'

export const sxs = makeSx({
    dialogPaper: {
        width: '100%',
        maxWidth: {
            xs: '85%',
            xl: '90rem',
        },
    },
    dialogContent: {
        width: '100%',
        boxSizing: 'border-box',
        padding: '1.5rem',
        alignItems: 'center',
    },
    dialogHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    dialogTitle: {
        color: '#000',
        fontWeight: 'bold',
        fontSize: '1.375rem',
    },
    dialogSubtitle: {
        color: palette.transmission[700],
    },
    dialogCloseButton: {
        border: `2px solid ${palette.typography[900]}`,
        '& svg': {
            width: '1.5rem',
            height: '1.5rem',
            fill: palette.typography[900],
        },
    },
})
